import { Component, OnInit, Input } from '@angular/core';
import { AgregarPuntoComponent } from '../agregar-punto/agregar-punto.component';
import { MatDialog } from '@angular/material/dialog';
import { Gtp } from 'src/app/shared/gtp';

@Component({
  selector: 'app-mapa-infowindow',
  templateUrl: './mapa-infowindow.component.html',
  styleUrls: ['./mapa-infowindow.component.scss']
})
export class MapaInfowindowComponent implements OnInit {

  @Input() punto: any;
  public showTabs:any = false;
  public tipoDePlan:any = '';

  constructor(
    public dialog: MatDialog,
    private gtp: Gtp,
  ) {
    let user = JSON.parse(this.gtp.getUserData());
    this.tipoDePlan = (user.cliente_plan_id == 1) ? "planBasico" : "planFull";
  }

  ngOnInit() {
    if (this.punto.eventos || this.punto.puntoscercanos){
      this.showTabs = true;
    }
  }

  popAddPunto(){
    this.dialog.open(AgregarPuntoComponent, {
      minWidth: 700,
      data: {
        latitud: this.punto.latitud,
        longitud: this.punto.longitud,
      }
    });
  }

}
